import { makeAutoObservable } from "mobx"
import { PossibleAnswer, PossibleAnswerProps } from "../models/PossibleAnswer"

export class PossibleAnswerList {
  items: PossibleAnswer[]

  constructor(params?: PossibleAnswerProps[]) {
    makeAutoObservable(this, {}, { autoBind: true })
    if (params) {
      this.items = params.map((pa) => new PossibleAnswer(pa))
    }

    this.maybePushDefaultPossibleAnswers()
  }

  deleteAll() {
    this.items.forEach((pa) => (pa.delete = true))
  }

  pushNewPossibleAnswer() {
    this.items.push(new PossibleAnswer({}))
  }

  clearPossibleAnswers() {
    this.items = []
  }

  maybePushDefaultPossibleAnswers() {
    if (this.items.length === 0) {
      this.pushNewPossibleAnswer()
      this.pushNewPossibleAnswer()
    }
  }
}
